(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-longi-set"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-flip')) {
    class RsFlip extends HTMLElement {
      connectedCallback() {
        this.imgs = Array.from(this.querySelectorAll('.rs-flip__img'));
        const n = this.imgs.length;
        if (n < 2) return;
        const offset = parseInt(this.dataset.offset || '0', 10);
        this.i = offset === -1 ? Math.floor(n / 2) : offset % n;
        this.show();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const ms = parseInt(this.dataset.interval || '3000', 10);
        this.timer = setInterval(() => {
          this.i = (this.i + 1) % n;
          this.show();
        }, ms);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      show() {
        this.imgs.forEach((img, k) => img.classList.toggle('is-active', k === this.i));
      }
    }
    customElements.define('rs-flip', RsFlip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-tee-set"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-flip')) {
    class RsFlip extends HTMLElement {
      connectedCallback() {
        this.imgs = Array.from(this.querySelectorAll('.rs-flip__img'));
        const n = this.imgs.length;
        if (n < 2) return;
        const offset = parseInt(this.dataset.offset || '0', 10);
        this.i = offset === -1 ? Math.floor(n / 2) : offset % n;
        this.show();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const ms = parseInt(this.dataset.interval || '3000', 10);
        this.timer = setInterval(() => {
          this.i = (this.i + 1) % n;
          this.show();
        }, ms);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      show() {
        this.imgs.forEach((img, k) => img.classList.toggle('is-active', k === this.i));
      }
    }
    customElements.define('rs-flip', RsFlip);
  }

  } catch(e) { console.error(e); }
})();
})();
